import React from "react";
import phone from "../images/phone.png";
import logo from "../images/logo.png";
import edsdough from "../images/edsdough.svg";
import { useSpring, animated } from "react-spring";

export default function Hero() {
  const fader1 = useSpring({ opacity: 1, from: { opacity: 0 } });
  const calc = (x, y) => [
    -(y - window.innerHeight / 2.5) / 20,
    (x - window.innerWidth / 2.5) / 20,
    1.1,
  ];
  const trans = (x, y, s) =>
    `perspective(800px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`;
  const [props, set] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 2, tension: 150, friction: 40 },
  }));

  return (
    <div className="hero">
      <animated.div className="hero-contain" style={fader1}>
        <div className="LeftSide">
          <animated.div
            onMouseMove={({ clientX: x, clientY: y }) =>
              set({ xys: calc(x, y) })
            }
            onMouseLeave={() => set({ xys: [0, 0, 1] })}
            style={{ transform: props.xys.interpolate(trans) }}
          >
            <img src={phone} alt="Phone Device" />
          </animated.div>
        </div>

        <div className="RightSide">
          <img className="firstimg" src={logo} alt="Main Logo" />
          <img src={edsdough} alt="Signature" />
        </div>
      </animated.div>
    </div>
  );
}
